"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
var _sweetalert = require("sweetalert2/src/sweetalert2");
var _sweetalert2 = _interopRequireDefault(_sweetalert);
var _jsCookie = require("js-cookie");
var _jsCookie2 = _interopRequireDefault(_jsCookie);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
(0, _jquery2.default)(function () {
  if (!_jsCookie2.default.get('cookiebar') == 1) {
    _sweetalert2.default.fire({
      position: "bottom-left",
      title: "Política general sobre Cookies",
      text: "En Wong.pe nos preocupamos por mejorar tu experiencia de compra, sin descuidar la protección de tus datos personales. En consecuencia Wong.pe, usa dos tipos de cookies las Funcionales y las de Analítica y Optimización ¿consiente el uso de las cookies?",
      confirmButtonText: "Sí Acepto",
      showCancelButton: false,
      cancelButtonText: "Cerrar",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: 'swal2-backdrop-show',
      footer: '<div class="content-footer" style="width:100%;display:inline-block; text-align:center;"><a href="https://wong.pe/institucional/politicas-de-cookies" target="_blank" style=";display:inline-block; margin:0 10px;"><u>Política de Cookies</u></a></div>',
      customClass: {
        container: 'swal2-shown',
        htmlContainer: 'swal2-content'
      }
    }).then(function (result) {
      if (result.isConfirmed) {
        _jsCookie2.default.set('cookiebar', 1, {
          expires: 365,
          path: '/'
        });
      }
      _sweetalert2.default.close();
    });
  }
});